<template>
  <div>
    <input
      id="fileInput"
      ref="file"
      type="file"
      style="display: none"
      @change="setPhoto"
    >
    <input
      id="recommendationLetterFileInput"
      ref="recommendRef"
      type="file"
      style="display: none"
      @change="setRecommendationLetter"
    >
    <input
      id="productDocsFileInput"
      ref="docRef"
      type="file"
      style="display: none"
      @change="setProductDoc"
    >
    <Breadcrumbs
      :breadcrumbs="[
        { text: $t('dashboardVue.dashboard'), link: 'welcome' },
        { text: 'Məhsullar və Xidmətlərim', link: 'myProductsPage'},
        { text: 'Yeni Məhsul və ya Xidmət', link: '',active: true },
      ]"
    />
    <div
      class="container-fluid mt-4"
      style="max-width: 1800px"
    >
      <h3 class="mb-3">
        Yeni məhsul və ya xidmət yarat
      </h3>
      <form @submit.prevent="submitForm">
        <div class="card">
          <div class="card-body">
            <label
              for="new_request_sector"
              class="lead font-weight-bold"
            >
              <span>Məhsulunuz hansı sahəyə aiddir?</span>

            </label>
            <br>
            <span class="text-secondary">*Məhsul və xidmətləniz bu sektorlarda yayımlanacaq. Əgər məhsul və xidmətiniz seçilmiş sektorlara uyğun deyilsə, aşağıdakı fəaliyyət sahələrindən seçim edərək əlavə edə və ya dəyişə bilərsiniz. Maksimum 3 sektor seçilə bilər. Bu əməliyyat sizin məhsul və ya xidmətin axtarış zamanı asan tapılmasına kömək edir.</span>
            <SelectedSectorView
              :sectors="productSectors"
              :parent-id="0"
            />
            <div class="mt-3">
              <button
                v-b-modal.modal-sector-selection
                type="button"
                class="btn btn-sm btn-primary"
              >
                {{ $t('companyProfile.faliyytSahsiniSein') }}
              </button>
            </div>
          </div>
        </div>
        <div class="card mt-3">
          <div class="card-body">
            <div class="form-group row">
              <label
                for="productType"
                class="col-sm-2 col-form-label"
              >Məhsulun tipi</label>
              <div class="col-sm-4">
                <select
                  id="productType"
                  v-model="formData.productType"
                  class="form-control"
                >
                  <option value="0">
                    Məhsul
                  </option>
                  <option value="1">
                    Xidmət
                  </option>
                </select>
              </div>
            </div>
            <div class="form-group row">
              <label
                for="productName"
                class="col-sm-2 col-form-label"
              >Məhsul/Xidmətin adı</label>
              <div class="col-sm-10">
                <input
                  id="productName"
                  v-model="formData.productName"
                  type="text"
                  class="form-control"
                  placeholder="Məhsul/Xidmətin adı"
                >
                <div
                  v-if="validationErrors.productName"
                  class="text-danger"
                >
                  {{ validationErrors.productName }}
                </div>
              </div>
            </div>
            <div class="form-group row">
              <label
                for="keywords"
                class="col-sm-2 col-form-label"
              >Açar sözlər əlavə edin</label>
              <div class="col-sm-10">
                <input
                  id="keywords"
                  v-model="newKeyword"
                  type="text"
                  class="form-control"
                  placeholder="Açar sözləri daxil edin və Enter'ə basın"
                  @keyup.enter="addKeyword"
                >
                <div class="mt-2 keyword-container">
                  <span
                    v-for="(keyword, index) in keywords"
                    :key="index"
                    class="keyword-badge"
                  >
                    {{ keyword }}
                    <button
                      type="button"
                      class="keyword-close"
                      @click="removeKeyword(index)"
                    >
                      &times;
                    </button>
                  </span>
                </div>

                <span
                  class="text-primary"
                  style="font-size: 12px"
                >
                  Qeyd: Məhsul və ya xidmətinizin axtarış zamanı rahat tapılması üçün doğru açar sözləri qeyd edin. Məsələn:  "Ovuc daşlayıcı" adlı məhsula  "Laqonda" sözünü yaza bilərsiz. Çünki çox insan laqonda kimi tanıyır bu sözü.  Digər misal: "Yanğından mühafizə" ifadəsinə "yangin", "mühafize" sözləri ilə açar sözlər yaza bilərsiz. Sözün cümlədə deyiliş formalarını da əlavə edə bilərsiz.
                </span>
              </div>
            </div>
            <div class="form-group row">
              <label
                for="description"
                class="col-sm-2 col-form-label"
              >Məhsul haqqında məlumat</label>
              <div class="col-sm-10">
                <textarea
                  id="description"
                  v-model="formData.description"
                  class="form-control"
                  rows="3"
                  placeholder="Məhsul haqqında məlumat yazın"
                />
                <div
                  v-if="formData.description.length>0 && formData.description.length<20"
                  class="text-danger"
                >
                  Description must be at least 20 characters long.
                </div>
              </div>
            </div>
            <div class="form-group row">
              <label class="col-sm-2 col-form-label">Məhsul üzrə şəkil və videolar</label>
              <div class="col-sm-10">
                <div class="row">
                  <div
                    v-for="(f, i) in productImages"
                    :key="f.path"
                    class="col-md-3 mb-3"
                  >
                    <div class="card position-relative">
                      <a
                        v-if="isPhoto(f.path)"
                        target="_blank"
                        :href="getPhoto(f.path, '')"
                      >
                        <img
                          :src="getPhoto(f.path, 'thumbnailCropped')"
                          class="card-img-top"
                          :alt="$t('newRequest.requestPhoto')"
                        >
                      </a>
                      <a
                        v-else
                        target="_blank"
                        :href="getPhoto(f.path, '')"
                        class="card h-100 border border-dark text-center"
                      >
                        <div class="card-body d-flex justify-content-center align-items-center">
                          {{ $t('newAUCRequest.lavFayl') }} <br> *.{{ f.path.split('.').pop() }}
                        </div>
                      </a>
                      <div
                        class="position-absolute top-0 end-0 p-2 bg-dark bg-opacity-75 text-white delete-button"
                        style="cursor: pointer;"
                      >
                        <feather
                          type="trash"
                          @click="deleteFile(i)"
                        />
                      </div>
                      <div
                        v-if="isImage(f.path)"
                        class="position-absolute bottom-0 start-0 p-2 bg-white cover-photo"
                        style="z-index: 10;"
                      >
                        <input
                          v-model="formData.coverPhoto"
                          type="radio"
                          :value="f.path"
                        >
                        <label>Cover</label>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  v-if="productImages.length < 8"
                  class="col-md-3 mb-3"
                  style="cursor: pointer"
                  @click.prevent="selectPhoto(-1)"
                >
                  <div
                    class="card bg-primary h-200 text-center text-white d-flex justify-content-center align-items-center"
                    style="height: 30px"
                  >
                    <div>{{ $t('newAUCRequest.ykl') }}</div>
                  </div>
                </div>
                <div class="text-danger">
                  * Məhsul\Xidmət barədə şəkil və ya video yükləyə bilərsiz. Maksimum 8 fayl yükləyə bilərsiz. Maksimum
                  bir faylın həcmi 25 meqabayt.
                </div>
                <div
                  v-if="uploadProgress > 0 && uploadProgress < 100"
                  class="progress mt-2"
                >
                  <div
                    class="progress-bar progress-bar-striped progress-bar-animated"
                    role="progressbar"
                    :style="{ width: `${uploadProgress}%` }"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="card mt-3">
          <div class="card-body">
            <div class="form-group row">
              <label
                for="price"
                class="col-sm-2 col-form-label"
              >Məhsulun qiyməti/ədəd</label>
              <div class="col-sm-2">
                <label>Qiymət/Valyuta</label>
                <div class="input-group">
                  <input
                    id="price"
                    v-model="formData.price"
                    type="text"
                    class="form-control"
                    placeholder="5"
                  >
                  <div class="input-group-append ml-2">
                    <select
                      v-model="formData.currency"
                      class="form-control"
                    >
                      <option value="AZN">
                        AZN
                      </option>
                      <option value="USD">
                        USD
                      </option>
                      <option value="EUR">
                        EUR
                      </option>
                      <option value="RUB">
                        RUBL
                      </option>
                      <option value="TRY">
                        TL
                      </option>
                    </select>
                  </div>
                  <div
                    v-if="validationErrors.price"
                    class="text-danger"
                  >
                    {{ validationErrors.price }}
                  </div>
                </div>
              </div>
              <div class="col-sm-2">
                <label>Say</label>
                <input
                  id="minimumQuantity"
                  v-model="formData.minimumQuantity"
                  type="number"
                  step="any"
                  class="form-control"
                  placeholder="100"
                >
                <div
                  v-if="validationErrors.minimumQuantity"
                  class="text-danger"
                >
                  {{ validationErrors.minimumQuantity }}
                </div>
              </div>
              <div class="col-sm-3">
                <label>Vahid</label>
                <select
                  v-if="formData.productType==='1'"
                  v-model="formData.unit"
                  class="form-control"
                  required
                >
                  <option
                    v-for="v in serviceUnits"
                    :key="v"
                    :value="v"
                  >
                    {{ v }}
                  </option>
                </select>
                <select
                  v-else
                  v-model="formData.unit"
                  class="form-control"
                  required
                >
                  <option
                    v-for="v in productUnits"
                    :key="v"
                    :value="v"
                  >
                    {{ v }}
                  </option>
                </select>
              </div>
              <div class="col-sm-2">
                <div class="form-check">
                  <input
                    id="discountOption"
                    v-model="formData.discountOption"
                    class="form-check-input"
                    type="checkbox"
                  >
                  <label
                    class="form-check-label green"
                    for="discountOption"
                  >Endirim barədə danışıqlara açığam</label>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="card mt-3">
          <div class="card-body">
            <div class="form-group row">
              <label class="col-sm-2 col-form-label">Minimum sifariş miqdarı</label>
              <div class="col-sm-10">
                <div
                  v-for="(order, index) in formData.minimumOrderQuantities"
                  :key="index"
                  class="row mb-2"
                >
                  <div class="col-sm-3">
                    <label>Say</label>

                    <div class="input-group">
                      <input
                        v-model="order.quantity"
                        type="number"
                        step="any"
                        class="form-control"
                        placeholder="100"
                      >
                      <div>
                        <span class="input-group-append input-group-text">{{ formData.unit }}</span>
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-3">
                    <label>Qiymət</label>
                    <div class="input-group">
                      <input
                        v-model="order.price"
                        type="text"
                        class="form-control"
                        :placeholder="`400 ${formData.currency}`"
                      >
                      <div>
                        <span class="input-group-append input-group-text">{{ formData.currency }}</span>
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-3 d-flex align-items-center">
                    <button
                      class="btn btn-danger"
                      @click.prevent="removeOrder(index)"
                    >
                      X
                    </button>
                  </div>
                </div>
                <button
                  class="btn btn-primary"
                  @click.prevent="addOrder"
                >
                  +
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="card mt-3">
          <div class="card-body">
            <div class="form-group row">
              <label
                for="validityDate"
                class="col-sm-2 col-form-label"
              >Qiymət təklifinin etibarlıq müddəti</label>
              <div class="col-sm-4">
                <input
                  id="validityDate"
                  v-model="formData.validityDate"
                  type="date"
                  class="form-control"
                >
              </div>
            </div>
          </div>
        </div>
        <div class="card mt-3">
          <div class="card-body">
            <div class="form-group row">
              <label class="col-sm-2 col-form-label">Əlavə məlumat</label>
              <div class="col-sm-10">
                <div class="form-group row">
                  <label class="col-sm-2 col-form-label">Məhsul barədə sənədlər</label>
                  <div class="col-sm-10">
                    <div class="col-md-9 text-secondary">
                      Məhsulun orijinallığı və ya mənşə sertifkatı barəsində sənədləri yükləyə bilərsiz.
                    </div>
                    <div class="row align-items-center mb-2">
                      <div
                        v-for="(f, i) in productDocs"
                        :key="f.path"
                        class="col-md-3 mb-3"
                      >
                        <div class="card position-relative">
                          <a
                            v-if="isPhoto(f.path)"
                            target="_blank"
                            :href="getPhoto(f.path, '')"
                          >
                            <img
                              :src="getPhoto(f.path, 'thumbnailCropped')"
                              class="card-img-top"
                              :alt="$t('newRequest.requestPhoto')"
                            >
                          </a>
                          <a
                            v-else
                            target="_blank"
                            :href="getPhoto(f.path, '')"
                            class="card h-100 border border-dark text-center"
                          >
                            <div class="card-body d-flex justify-content-center align-items-center">
                              {{ $t('newAUCRequest.lavFayl') }} <br> *.{{ f.path.split('.').pop() }}
                            </div>
                          </a>
                          <div
                            class="position-absolute top-0 end-0 p-2 bg-dark bg-opacity-75 text-white"
                            style="cursor: pointer;"
                          >
                            <feather
                              type="trash"
                              @click="deleteProductDoc(i)"
                            />
                          </div>
                        </div>
                      </div>
                    </div>

                    <div
                      v-if="productDocs.length < 8"
                      class="col-md-3 mb-3"
                      style="cursor: pointer"
                      @click.prevent="selectProductDoc"
                    >
                      <div
                        class="card bg-primary h-200 text-center text-white d-flex justify-content-center align-items-center"
                        style="height: 30px"
                      >
                        <div>{{ $t('newAUCRequest.ykl') }}</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="form-group row mt-2">
                  <label class="col-sm-2 col-form-label">Məhsul və ya xidmət barəsində tövsiyyə məktubu</label>
                  <div class="col-sm-10">
                    <div class="col-md-9 text-secondary">
                      Müştərilərinizin məhsulunuz və xidmətləriniz haqqında verdiyi rəy məktubunu yükləyə bilərsiz
                    </div>
                    <div class="row">
                      <div
                        v-for="(f, i) in recommendationLetters"
                        :key="f.path"
                        class="col-md-3 mb-3"
                      >
                        <div class="card position-relative">
                          <a
                            v-if="isPhoto(f.path)"
                            target="_blank"
                            :href="getPhoto(f.path, '')"
                          >
                            <img
                              :src="getPhoto(f.path, 'thumbnailCropped')"
                              class="card-img-top"
                              :alt="$t('newRequest.requestPhoto')"
                            >
                          </a>
                          <a
                            v-else
                            target="_blank"
                            :href="getPhoto(f.path, '')"
                            class="card h-100 border border-dark text-center"
                          >
                            <div class="card-body d-flex justify-content-center align-items-center">
                              {{ $t('newAUCRequest.lavFayl') }} <br> *.{{ f.path.split('.').pop() }}
                            </div>
                          </a>
                          <div
                            class="position-absolute top-0 end-0 p-2 bg-dark bg-opacity-75 text-white"
                            style="cursor: pointer;"
                          >
                            <feather
                              type="trash"
                              @click="deleteRecommendationLetter(i)"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      v-if="recommendationLetters.length < 8"
                      class="col-md-3 mb-3"
                      style="cursor: pointer"
                      @click.prevent="selectRecommendationLetter"
                    >
                      <div
                        class="card bg-primary h-200 text-center text-white d-flex justify-content-center align-items-center"
                        style="height: 30px"
                      >
                        <div>{{ $t('newAUCRequest.ykl') }}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="form-group row mt-3">
          <div class="col-sm-10 offset-sm-2">
            <button
              type="submit"
              class="btn btn-success"
            >
              Yüklə
            </button>
          </div>
        </div>
      </form>
    </div>
    <b-modal
      id="modal-sector-selection"
      centered
      :title="$t('companyProfile.faliyytSahsiniSein')"
      :no-close-on-backdrop="true"
      :no-close-on-esc="true"
      :hide-header-close="false"
      class="theme-modal"
      :busy="false"
      :hide-footer="true"
    >
      <sector_selection_modal
        :max-parent-selection="3"
        :max-selection="100"
        :parent-sector="null"
        :selected="productSectors"
        @done="sectorSelected($event)"
      />
    </b-modal>
  </div>
</template>

<script>
import {mapState} from "vuex";
import {mediaBase} from "@/repositories/Repository";
import SelectedSectorView from "@/components/SelectedSectorsView.vue";
import Sector_selection_modal from "@/components/sector_selection_modal.vue";
import {getPhoto} from "@/repositories/Utils";
import {getCompanyDetails, upload} from "@/repositories/GeneralDataRepository";
import {createProduct} from "@/repositories/ProductDataRepository";

export default {
  components: {Sector_selection_modal, SelectedSectorView},
  data() {
    return {
      mediaBase: mediaBase,
      productSectors: [],
      productImages: [],
      productDocs: [],
      productUnits: this.$t("productUnits"),
      serviceUnits: this.$t("serviceUnits"),
      recommendationLetters: [],
      uploadProgress: 0,
      photoIndex: 0,
      keywords: [],
      newKeyword: '',
      formData: {
        productType: "0",
        currency: 'AZN', // Default currency
        productName: "",
        description: "",
        price: "",
        discountOption: false,
        unit: "ədəd",
        minimumOrderQuantities: [],
        minimumQuantity: "",
        validityDate: "",
        coverPhoto: ""
      },
      validationErrors: {
        productName: "",
        description: "",
        price: "",
        minimumQuantity: "",
        coverPhoto: ""
      }
    };
  },
  mounted() {
    this.getCompanyDetails()
  },
  computed: {
    ...mapState({
      token: (state) => state.auth.token,
      user: (state) => state.auth.user,
      company: (state) => state.auth.company,
      sessionType: (state) => state.auth.sessionType,
      profile: (state) => state.auth.profile,
      position: (state) => state.auth.position,
      userPackageStatus: (state) => state.auth.userPackageStatus,
      userPackage: (state) => state.auth.userPackage,
    }),
  },
  methods: {
    isPhoto(path) {
      return ['jpg', 'png', 'gif', 'jpeg', "jfif"].indexOf(path.toLowerCase().split('.').pop()) > -1;
    },
    isImage(path) {
      const imageTypes = ['jpg', 'jpeg', 'png', 'gif', 'jfif'];
      return imageTypes.includes(path.toLowerCase().split('.').pop());
    },
    getPhoto(path, size) {
      return getPhoto(path, size);
    },
    selectPhoto(index) {
      this.photoIndex = index;
      window.document.getElementById('fileInput').click();
    },
    getCompanyDetails() {
      getCompanyDetails(this.token, this.company.id).then(data => {
        if (data.code === 200) {
          this.productSectors = data.sectors;
        } else {
          this.$router.push({name: 'changeAccount'});
        }
      })
    },
    sectorSelected(sectors) {
      this.productSectors = sectors;

      this.$bvModal.hide('modal-sector-selection');
    },
    deleteFile(index) {
      if (confirm(this.$t("general.fileDltConfirm"))) {
        this.productImages.splice(index, 1);
        if (this.formData.coverPhoto === this.productImages[index].path) {
          this.formData.coverPhoto = "";
        }
      }
    },
    setPhoto() {
      let currentFile = this.$refs.file.files[0];
      const imageTypes = ['image/jpeg', 'image/png', 'image/gif', 'image/jfif'];
      const videoTypes = ['video/mp4', 'video/avi', 'video/mov'];
      const allTypes = [...imageTypes, ...videoTypes];

      if (!allTypes.includes(currentFile.type)) {
        this.$swal({
          title: 'Error',
          text: this.$t("invalidFileType"),
          icon: 'error',
        });
        return;
      }

      if (this.productImages.length >= 8) {
        this.$swal({
          title: 'Error',
          text: this.$t("maximumPhotoLimitReached"),
          icon: 'error',
        });
        return;
      }

      if (window.File && window.FileReader && window.FileList && window.Blob) {
        upload(this.token, 'productPhoto', currentFile, (event) => {
          this.uploadProgress = Math.round((100 * event.loaded) / event.total);
        })
            .then((response) => {
              this.uploadProgress = 100;
              if (response.data.code === 200) {
                this.productImages.push({
                  id: 0,
                  path: response.data.path,
                  type: "productPhoto",
                });
                // Set cover photo automatically if it's the first image
                if (!this.formData.coverPhoto && imageTypes.includes(currentFile.type)) {
                  this.formData.coverPhoto = response.data.path;
                }
              } else {
                this.$swal({
                  title: `Error ${response.data.code}`,
                  text: `${response.data.message}`,
                  icon: 'error',
                });
              }
            })
            .catch((e) => {
              this.uploadProgress = 0;
              this.$swal({
                title: 'Error',
                text: this.$t("cldNotUploadFile") + e,
                icon: 'error',
              });
            });
      } else {
        this.$swal({
          title: 'Error',
          text: this.$t("photoUploadNotSpprtdBrowser"),
          icon: 'error',
        });
      }
    },
    addKeyword() {
      if (this.newKeyword.trim() && !this.keywords.includes(this.newKeyword.trim())) {
        this.keywords.push(this.newKeyword.trim());
        this.newKeyword = '';
      }
    },
    removeKeyword(index) {
      this.keywords.splice(index, 1);
    },
    selectProductDoc() {
      window.document.getElementById('productDocsFileInput').click();
    },
    setProductDoc() {
      let currentFile = this.$refs.docRef.files[0];
      if (this.productDocs.length >= 8) {
        this.$swal({
          title: `Error`,
          text: this.$t("maximumDocumentLimitReached"),
          icon: 'error',
        });
        return;
      }
      if (window.File && window.FileReader && window.FileList && window.Blob) {
        upload(this.token, 'productDocs', currentFile, (event) => {
          this.uploadProgress = Math.round((100 * event.loaded) / event.total);
        }, true)
            .then((response) => {
              this.uploadProgress = 100;
              if (response.data.code === 200) {
                this.productDocs.push({
                  id: 0,
                  path: response.data.path,
                  type: "request",
                });
              } else {
                this.$swal({
                  title: `Error ${response.data.code}`,
                  text: `${response.data.message}`,
                  icon: 'error',
                });
              }
            })
            .catch((e) => {
              this.uploadProgress = 0;
              this.$swal({
                title: `Error`,
                text: this.$t("cldNotUploadFile") + e,
                icon: 'error',
              });
            });
      } else {
        this.$swal({
          title: `Error`,
          text: this.$t("photoUploadNotSpprtdBrowser"),
          icon: 'error',
        });
      }
    },
    deleteProductDoc(index) {
      if (confirm(this.$t("general.fileDltConfirm"))) {
        this.productDocs.splice(index, 1);
      }
    },
    selectRecommendationLetter() {
      window.document.getElementById('recommendationLetterFileInput').click();
    },
    setRecommendationLetter() {
      let currentFile = this.$refs.recommendRef.files[0];
      if (this.recommendationLetters.length >= 8) {
        this.$swal({
          title: `Error`,
          text: this.$t("maximumDocumentLimitReached"),
          icon: 'error',
        });
        return;
      }
      if (window.File && window.FileReader && window.FileList && window.Blob) {
        upload(this.token, 'recommendationLetters', currentFile, (event) => {
          this.uploadProgress = Math.round((100 * event.loaded) / event.total);
        }, true)
            .then((response) => {
              this.uploadProgress = 100;
              if (response.data.code === 200) {
                this.recommendationLetters.push({
                  id: 0,
                  path: response.data.path,
                  type: "request",
                });
              } else {
                this.$swal({
                  title: `Error ${response.data.code}`,
                  text: `${response.data.message}`,
                  icon: 'error',
                });
              }
            })
            .catch((e) => {
              this.uploadProgress = 0;
              this.$swal({
                title: `Error`,
                text: this.$t("cldNotUploadFile") + e,
                icon: 'error',
              });
            });
      } else {
        this.$swal({
          title: `Error`,
          text: this.$t("photoUploadNotSpprtdBrowser"),
          icon: 'error',
        });
      }
    },
    deleteRecommendationLetter(index) {
      if (confirm(this.$t("general.fileDltConfirm"))) {
        this.recommendationLetters.splice(index, 1);
      }
    },
    addOrder() {
      this.formData.minimumOrderQuantities.push({quantity: "", unit: "ədəd", price: ""});
    },
    removeOrder(index) {
      this.formData.minimumOrderQuantities.splice(index, 1);
    },
    validateForm() {
      let isValid = true;
      this.validationErrors = {
        productName: "",
        description: "",
        price: "",
        minimumQuantity: "",
        coverPhoto: ""
      };

      if (!this.productSectors.length) {
        this.$swal("Error", "Zəhmət olmasa Fəaliyyət sahələrini seçin", "error");
        isValid = false;
      }

      if (this.formData.productName.length < 3) {
        this.validationErrors.productName = "Product name must be at least 3 characters long.";
        isValid = false;
      }

      if (this.formData.description.length < 20) {
        this.validationErrors.description = "Description must be at least 20 characters long.";
        isValid = false;
      }

      if (!this.productImages.length) {
        this.$swal("Error", "Please add an image", "error");
        isValid = false;
      }


      if (!this.formData.coverPhoto) {
        this.validationErrors.coverPhoto = "Please select a cover photo.";
        isValid = false;
      }

      if (!this.formData.price || isNaN(this.formData.price)) {
        this.validationErrors.price = "Price is required and must be a number.";
        isValid = false;
      }

      if (this.formData.minimumQuantity === "" || this.formData.minimumQuantity === null || isNaN(this.formData.minimumQuantity)) {
        this.validationErrors.minimumQuantity = "Minimum quantity is required and must be a number.";
        isValid = false;
      }

      if (this.formData.minimumOrderQuantities.length > 0) {
        this.formData.minimumOrderQuantities.forEach((order, index) => {
          if ((order.quantity === "" || order.quantity === null) || isNaN(order.quantity)) {
            this.$swal("Error", `Quantity at row ${index + 1} is required and must be a number.`, "error");
            isValid = false;
          }
          if (!order.price || isNaN(order.price)) {
            this.$swal("Error", `Price at row ${index + 1} is required and must be a number.`, "error");
            isValid = false;
          }
        });
      }

      return isValid;
    },
    submitForm() {

      if (this.validateForm()) {
        const minimumOrderQuantitiesMap = {};
        this.formData.minimumOrderQuantities.forEach(order => {
          minimumOrderQuantitiesMap[parseFloat(order.quantity)] = parseFloat(order.price);
        });

        const formDataForBackend = {
          ...this.formData,
          minimumOrderQuantities: minimumOrderQuantitiesMap,
          keywords: this.keywords.join(',')
        };
        createProduct(
            this.token,
            formDataForBackend,
            this.productSectors,
            this.productImages,
            this.recommendationLetters,
            this.productDocs
        ).then(data => {
          if (data.code === 200) {
            this.$router.replace('/dashboard/product/' + data.id);
          } else {
            this.$swal({
              title: `Error ${data.code}`,
              text: `${data.message}`,
              icon: 'error'
            })
          }
        })
      }
    }
  }
};
</script>


<style scoped>
.card-img-top {
  max-height: 200px;
  object-fit: cover;
}

.card .delete-button {
  top: 10px;
  right: 10px;
}

.card .cover-photo {
  bottom: 10px;
  left: 10px;
}

input::placeholder,
textarea::placeholder {
  transition: color 0.3s ease;
}

input:focus::placeholder,
textarea:focus::placeholder {
  color: transparent;
}

.keyword-container {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.keyword-badge {
  display: inline-flex;
  align-items: center;
  background-color: #007bff;
  color: white;
  padding: 5px 10px;
  border-radius: 20px;
  font-size: 14px;
}

.keyword-close {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(255, 255, 255, 0.3);
  color: white;
  border: none;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  font-size: 14px;
  margin-left: 8px;
  cursor: pointer;
  transition: background-color 0.2s;
}

.keyword-close:hover {
  background-color: rgba(255, 255, 255, 0.5);
}
</style>
